import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const SUPPORTED_LANGUAGES = ['en', 'tr', 'fr', 'es', 'ru', 'de', 'zh', 'it', 'ja', 'ko', 'lt', 'pt', 'ar'];

const translationLoaders = {
    en: () => import('../locales/en/translation.json'),
    tr: () => import('../locales/tr/translation.json'),
    fr: () => import('../locales/fr/translation.json'),
    es: () => import('../locales/es/translation.json'),
    ru: () => import('../locales/ru/translation.json'),
    de: () => import('../locales/de/translation.json'),
    zh: () => import('../locales/zh/translation.json'),
    it: () => import('../locales/it/translation.json'),
    ja: () => import('../locales/ja/translation.json'),
    ko: () => import('../locales/ko/translation.json'),
    lt: () => import('../locales/lt/translation.json'),
    pt: () => import('../locales/pt/translation.json'),
    ar: () => import('../locales/ar/translation.json')
};

const dynamicImportBackend = {
    type: 'backend',
    init: () => {
    },
    read: (language, namespace, callback) => {
        const normalizedLanguage = (language || 'en').toLowerCase().split('-')[0];
        const selectedLanguage = SUPPORTED_LANGUAGES.includes(normalizedLanguage) ? normalizedLanguage : 'en';
        const loader = translationLoaders[selectedLanguage] || translationLoaders.en;

        loader()
            .then((module) => callback(null, module.default || module))
            .catch((error) => callback(error, null));
    }
};

i18n.use(LanguageDetector)
    .use(dynamicImportBackend)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        supportedLngs: SUPPORTED_LANGUAGES,
        nonExplicitSupportedLngs: true,
        ns: ['translation'],
        defaultNS: 'translation',
        load: 'languageOnly',
        initImmediate: true,
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false
        }
    }, (err, t) => {
        if (err) return console.error(err);
    });

export default i18n;